import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Footer from "../@footer";
import Support from '../../components/shared/Support';
import { HEADER } from '../../store/constant';
import LauanCopyright from '../@footer/LauanCopyright';


// ==============================|| STYLED ||============================== //

const StyledRoot = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  overflow: 'hidden',
});

const Section = styled('section')(({ theme }) => {
  console.log('%c theme', 'color: red', theme);
  return {
    flexGrow: 1,
    minHeight: '100%',
    paddingTop: HEADER.MOBILE_HEIGHT,
    [theme.breakpoints.up('lg')]: {
      paddingTop: 0
    },
  }
});




const BgContainer = ({ children }) => {
  return (
    <StyledRoot>
      { children }
    </StyledRoot>
  )
}


// ==============================|| Lauan LAYOUT ||============================== //

export default function LaborLayout() {
  return (
    <BgContainer>
      <Header />
      <Section>
         <Outlet />
      </Section>
      <Footer copyright={<LauanCopyright />} />
      <Support />
       {/* <ScrollRestoration getKey={getKey} /> */}
    </BgContainer>
  );
}
